import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const SHOTS = [
  ["/img/rory-start.jpg", "Rory at the very start"],
  ["/img/store-display.jpg", "Swole Bears display in a store"],
  ["/img/trio.jpg", "Three bags of Swole Bears"],
  ["/img/rory-students.jpg", "Rory speaking with students"],
  ["/img/facility.jpg", "Inside the Swole Bears production facility"],
  ["/img/box24.jpg", "A packed 24-bag box"],
  ["/img/rory-baseball.jpg", "Rory at a baseball game"],
  ["/img/rory-award.jpg", "Rory receiving his entrepreneurship award"],
];

const Shot = ({ src, alt, i, dup }) => (
  <figure aria-hidden={dup || undefined} className={`shrink-0 w-[62vw] sm:w-[300px] aspect-[4/5] rounded-[24px] overflow-hidden bg-white border border-[#1B1530]/10 ${i % 2 ? "rotate-2" : "-rotate-2"}`}>
    <img src={src} alt={dup ? "" : alt} loading="lazy" className="h-full w-full object-cover" />
  </figure>
);

export const PhotoStrip = () => (
  <section data-testid="home-photo-strip" className="py-20 lg:py-28 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
      <Reveal className="flex flex-wrap items-end justify-between gap-4 mb-10">
        <div>
          <Eyebrow className="text-[#FF5A5F] mb-4">Snapshots from the journey</Eyebrow>
          <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">Real bears. Real people.</h2>
        </div>
        <Link to="/reviews" data-testid="photo-strip-reactions-link" className="inline-flex items-center gap-2 h-12 px-6 rounded-full border-2 border-[#1B1530] font-bold hover:bg-[#1B1530] hover:text-white transition-colors">Watch first-bite reactions <ArrowRight className="h-4 w-4" /></Link>
      </Reveal>
    </div>
    <div className="group flex w-max gap-5 py-4 marquee-track hover:[animation-play-state:paused]" style={{ animationDuration: "60s" }}>
      {[...SHOTS, ...SHOTS].map(([src, alt], i) => <Shot key={`${src}-${i}`} src={src} alt={alt} i={i} dup={i >= SHOTS.length} />)}
    </div>
  </section>
);
